import { MILEAGE_UNIT } from 'types';

enum FORM_VALUES {
  CONTACT_NAME = 'contactName',
  CONTACT_NO = 'contactNo',
  EMAIL = 'email',
  MESSAGE = 'message',
  FINANCING_VEHICLE = 'financingVehicle',
  SCHEDULING_TEST_DRIVE = 'schedulingTestDrive',
  VEHICLE_TRADE_IN = 'vehicleTradeIn',
  VEHICLE_CONDITION = 'vehicleCondition',
  REGISTRATION_NO = 'registrationNo',
  MILEAGE = 'mileage',
  MILEAGE_UNIT = 'mileageType',
  SAVE_ENQUIRY = 'saveEnquiry',
}

interface IEnquiryData extends Partial<VehicleLookUpData> {
  contactName: string;
  message: string;
  email: string;
  contactNo?: string;
  financingVehicle: boolean;
  schedulingTestDrive: boolean;
  vehicleTradeIn: boolean;
  vehicleCondition: boolean;
  mileage?: string;
  mileageType?: MILEAGE_UNIT.KILOMETRES | MILEAGE_UNIT.MILES;
  registrationNo?: string;
  saveEnquiry: boolean;
}

interface VehicleLookUpData {
  bodyType?: string;
  country?: string;
  owners?: string;
  year?: string;
  colour?: string;
  transmission?: string;
  numDoors?: string;
  fuelType?: string;
  engine?: string;
  model?: string;
  make?: string;
  nct?: string;
  roadTax?: string;
  mileage?: string;
  mileageType?: MILEAGE_UNIT.KILOMETRES | MILEAGE_UNIT.MILES;
  apiVersion?: string;
  modelOnly?: string;
  seats?: string;
}

export { FORM_VALUES };
export type { IEnquiryData, VehicleLookUpData };
